module.exports = __webpack_public_path__ + "static/media/5.a1e08b68.jpg";